import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/**
 */
import { UPDATE_PATH, UPDATE_HISTORY, LOCATION_CHANGE, RESET_IMPRESSONS, IMPRESSION_REPORTED } from './actions';
import { PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW } from '../shared/actions/impressions';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    preventPageviewReset: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case IMPRESSION_REPORTED:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.elementId, action.eventData || true));

    case PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW:
      return _objectSpread(_objectSpread({}, state), {}, {
        preventPageviewReset: true
      });

    case RESET_IMPRESSONS:
    case UPDATE_HISTORY:
    case LOCATION_CHANGE:
    case UPDATE_PATH:
      // Manually prevent reset for navigation that doesn't warrant a new pageview
      if (state.preventPageviewReset) {
        return state;
      } // Impressions are tied to a pageview, so in-app transition should
      // let all impressions occur again


      return {};

    default:
      return state;
  }
});